export default "__VITE_ASSET__DI7rboTk__"